import { useQuery } from "@apollo/client";
import { CoinType, Query, vodabucksBalanceGQL } from "@onmo/graphql/graphql";
import { useWalletConfig } from "./useWalletConfig";

export const useVodabucksBalance = (userId?: string) => {
  const { isCurrencyEnabled } = useWalletConfig();
  const isEnabled = isCurrencyEnabled(CoinType.Vodabucks);

  const { data: vodabucksData } = useQuery<Query["vodabucksBalance"]>(
    vodabucksBalanceGQL,
    {
      variables: { input: { userId: userId || "" } },
      skip: !isEnabled,
    },
  );

  return { vbBalance: isEnabled ? vodabucksData?.balance ?? 0 : 0 };
};
